var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rmqclient-hint"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":_vm.color,"dark":""}},on),[_vm._v("mdi-"+_vm._s(_vm.icon))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.statusText))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }